import { toCSS, toJSON } from './cssjson';
import { StyleData } from './types';

export function toLine(styleKey: string) {
    return styleKey.replace(/([A-Z])/g, '-$1').toLowerCase();
}

export function toHump(name: String) {
    return name.replace(/-(\w)/g, function (all, letter) {
        return letter.toUpperCase();
    });
}

export function parseToCssCode(styleData: StyleData | any) {
    const parseStyleData: any = {};
    for (const styleKey in styleData) {
        parseStyleData[toLine(styleKey)] = styleData[styleKey];
    }

    const cssJson = {
        children: {
            '#main': {
                children: {},
                attributes: parseStyleData,
            },
        },
        attributes: {},
    };

    return toCSS(cssJson);
}

export function parseToStyleData(cssCode: string) {
    const styleData: any = {};

    try {
        const cssJson = toJSON(cssCode);
        const cssJsonData = cssJson?.children?.['#main']?.attributes;
        for (const key in cssJsonData) {
            styleData[toHump(key)] = cssJsonData[key];
        }
        // 转化key
    } catch (e: any) {
        console.error(e.message);
    }

    return styleData;
}

export const removeUnit = (value: string, isInt: boolean = true) => {
    if (value === '-0') {
        return '-';
    } else {
        const num = isInt ? parseInt(value) : parseFloat(value);

        return !isNaN(num) ? num : '';
    }
};

export const addUnit = (value: number | string, unit: string) => {
    if (value === '-') {
        return '-0';
    } else {
        return `${value}${unit}`;
    }
};

export const isEmptyValue = (value: any) => {
    return value === undefined || value === null || value === '';
};

export const isInt = (value: string) => {
    return value === '-' || !isNaN(parseInt(value));
};
